import { MUTATION_PREAPPROVAL_FORM, SchemaTypes } from '@allesauto/graphql';
import { ApolloError, useMutation } from '@apollo/client';

export const usePreApprovalFormMutation = (): {
  preApprovalFormRequest: (
    vehicleId: string,
    formData: SchemaTypes.PreApprovalInput
  ) => Promise<Pick<SchemaTypes.Mutation, 'calculatePreApproval'>>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [mutationPreapprovalForm, { loading, error }] = useMutation<
    Pick<SchemaTypes.Mutation, 'calculatePreApproval'>
  >(MUTATION_PREAPPROVAL_FORM);

  const preApprovalFormRequest = async (
    vehicleId: string,
    formData: SchemaTypes.PreApprovalInput
  ): Promise<Pick<SchemaTypes.Mutation, 'calculatePreApproval'>> => {
    const response = await mutationPreapprovalForm({
      variables: {
        vehicleId,
        input: formData,
      },
    });
    if (!response.data) {
      throw new Error('Data is missing in the response');
    }
    return response.data;
  };

  return {
    preApprovalFormRequest: preApprovalFormRequest,
    loading: loading,
    error: error,
  };
};
